import { KYMW6500Model } from '../kymw6500.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * タイムセールマスタ一覧の出力
 *
 * @export API通信成功時の処理
 * @class SaveCwsTimeSaleListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class SaveCwsTimeSaleListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW6500Model;
  private successFunc: Function;
  private vo: any;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof SaveCwsTimeSaleListService
   */
  private saveBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCodeFr: this.vo.orderCodeFr,
        OrderCodeTo: this.vo.orderCodeTo,
        CategoryCode: this.vo.categoryCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW6500Model} model
   * @param {string} orderCode
   * @param {string} categoryLevel
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof SaveCwsTimeSaleListService
   */
  execute(model: KYMW6500Model, vo: any, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('saveCwsTimeSaleList', this.saveBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof SaveCwsTimeSaleListService
   */
  success(data: any) {
    this.model.updateFileName(data);
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
